import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import RoomsShowcase from "../components/RoomsShowcase";
import WhyUs from "../components/WhyUs";
import TurinExperience from "../components/TurinExperience";
import ServicesStrip from "../components/ServicesStrip";
import OffersSection from "../components/OffersSection";
import ReviewsSection from "../components/ReviewsSection";
import ContactSection from "../components/ContactSection";
import BookingModal from "../components/BookingModal";
import StickyBookingBar from "../components/StickyBookingBar";
import PageSeo, { hotelJsonLd } from "../components/PageSeo";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SiteSettingsContext";
import { fetchRooms, fetchOffers, fetchServices, fetchExperiences, fetchReviews } from "../lib/api";

export default function HomePage() {
  const { lang } = useLang();
  const settings = useSettings();
  const [rooms, setRooms] = useState([]);
  const [offers, setOffers] = useState([]);
  const [services, setServices] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [bookOpen, setBookOpen] = useState(false);

  useEffect(() => {
    Promise.all([fetchRooms(), fetchOffers(), fetchServices(), fetchExperiences(), fetchReviews()])
      .then(([r, o, s, e, rv]) => {
        setRooms(r); setOffers(o); setServices(s); setExperiences(e); setReviews(rv);
      })
      .catch(() => {});
    // fetchers and setters are stable references (module imports / React setState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const title = lang === "en" ? settings.home_meta_title_en : settings.home_meta_title_it;
  const description = lang === "en" ? settings.home_meta_desc_en : settings.home_meta_desc_it;

  return (
    <div data-testid="home-page">
      <PageSeo
        title={title}
        description={description}
        pathIt="/it"
        pathEn="/en"
        jsonLd={hotelJsonLd(settings, { lang })}
      />
      <Hero onBook={() => setBookOpen(true)} />
      <RoomsShowcase rooms={rooms} />
      <WhyUs />
      <TurinExperience experiences={experiences} />
      <ServicesStrip services={services} />
      <OffersSection offers={offers} onBook={() => setBookOpen(true)} />
      <ReviewsSection reviews={reviews} />
      <ContactSection settings={settings} />
      <BookingModal open={bookOpen} onOpenChange={setBookOpen} />
      <StickyBookingBar onBook={() => setBookOpen(true)} />
    </div>
  );
}
